import React, { PropTypes } from 'react';
import { request } from '../actions/api';
import { observable, autorun, action, toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import Form, { FormBody, SelectInput, DateInput, SwitchInput } from './Form';
import moment from 'moment';
import Spinner from './Spinner';
import { getDisplayDate } from "../libs/date";
import DataTable from './DataTable';

@inject('dataSourceStore')
@observer
class DAQRawData extends React.Component {

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
  };

  slug = '/daq/raw_data';
  @observable columns = [
    { key: 'request_id', label: 'Request ID', sortable: true },
    { key: 'id', label: 'Raw Data ID', sortable: true },
    { key: 'code', label: 'Code', sortable: true },
    { key: 'server_time_utc', label: 'Server Time', sortable: true },
    { key: 'device_time_utc', label: 'Device Time', sortable: true },
    { key: 'parameter', label: 'Parameter', sortable: true },
    { key: 'value', label: 'Value' },
    { key: 'processed', label: 'Processed' },
  ];
  @observable loading = false;
  @observable items = [];
  @observable originList = [];
  @observable viewLocalTimezone = false;
  @observable filters = {
    origin_code: '',
    parameter_code: '',
    date_from: moment().format('YYYY-MM-DD'),
    date_to: moment().add(1, 'day').format('YYYY-MM-DD'),
    fetchIndex: 0
  };

  dispose;

  componentWillMount() {
    const { dataSourceStore } = this.props;
    dataSourceStore.fetchItems().then();
    this.dispose = autorun(() => {
      if (dataSourceStore.items) {
        let originList = [];
        dataSourceStore.items.map(item => {
          originList = [...originList, ...item.origins]
        });
        this.originList = originList;
      }
    })
  }

  @action onChangeOrigin = e => {
    this.filters.origin_code = e.target.value;
    this.filters.parameter_code = null;
    this.filters.fetchIndex = 0;
  };
  @action onChangeParameter = e => {
    this.filters.parameter_code = e.target.value;
    this.filters.fetchIndex = 0;
  };
  @action onChangeDateFrom = e => {
    this.filters.date_from = e.target.value;
    this.filters.fetchIndex = 0;
  };
  @action onChangeDateTo = e => {
    this.filters.date_to = e.target.value;
    this.filters.fetchIndex = 0;
  };

  @action onClickPrev = e => {
    this.filters.date = moment(this.filters.date).subtract(1, 'day').format('YYYY-MM-DD');
    this.onView(e);
  };

  @action onClickNext = e => {
    this.filters.date = moment(this.filters.date).add(1, 'day').format('YYYY-MM-DD');
    this.onView(e);
  };

  @action onLoadMore = e => {
    this.filters.fetchIndex++;
    this.onView(e);
  };

  @action onView = (e) => {
    e.preventDefault();
    const { notify } = this.context;
    this.loading = true;
    if (this.filters.fetchIndex === 0) this.items = [];
    else notify.startLoading({ message: 'Loading more data' });

    let filters = Object.assign({}, this.filters);
    request.fetchAllRawData(toJS(filters)).then(res => {
      this.items = [...this.items, ...res.map((item, index) => ({
        // id: this.items.length + index + 1,
        id: item.id,
        request_id: item.request_id,
        code: item.origin_code,
        server_time_utc: item.timestamp,
        device_time_utc: item.time,
        server_time_local: getDisplayDate(item.timestamp, { format: 'YYYY-MM-DDTHH:mm:ss.SSS' }) + 'Z',
        device_time_local: getDisplayDate(item.time, { format: 'YYYY-MM-DDTHH:mm:ss.SSS' }) + 'Z',
        parameter: item.parameter_code,
        value: item.value,
        processed: item.processed
      }))];
      this.loading = false;
      notify.stopLoading();
    }).catch(err => {
      this.loading = false;
      notify.error({ message: err.toString() })
    });
  };

  @action changeTimezone = () => {
    this.viewLocalTimezone = !this.viewLocalTimezone;
    if (this.viewLocalTimezone) {
      this.columns.find(item => item.label === 'Server Time').key = 'server_time_local';
      this.columns.find(item => item.label === 'Device Time').key = 'device_time_local'
    } else {
      this.columns.find(item => item.label === 'Server Time').key = 'server_time_utc';
      this.columns.find(item => item.label === 'Device Time').key = 'device_time_utc';
    }
  };

  render() {
    let selectedOrigin = this.filters.origin_code && this.originList.find(origin => origin.code.toString() === this.filters.origin_code.toString());

    return (
      <div>
        <Form>
          <FormBody>
            <div className='formInput'>
              <label>Origin Code</label>
              <input value={this.filters.origin_code} onChange={this.onChangeOrigin} list='dataOriginList' />
              <datalist id='dataOriginList'>{this.originList.map((item, index) => (<option key={`data-origin-input-option-${index}-${item.code}`} value={item.code} />))}</datalist>
            </div>
            {selectedOrigin && [<SelectInput
              key={'daq-raw-data-parameter_code'}
              label={'Parameter Code'}
              fields={{ label: 'code', value: 'code' }}
              value={this.filters.parameter_code}
              options={selectedOrigin.data_origin_parameters}
              onChange={this.onChangeParameter}
            />,
            <DateInput
              key={'daq-raw-data-date-from'}
              label="Date From"
              value={this.filters.date_from}
              onChange={this.onChangeDateFrom}
            />,
            <DateInput
              key={'daq-raw-data-date-to'}
              label="Date To"
              value={this.filters.date_to}
              onChange={this.onChangeDateTo}
            />]}
            <SwitchInput label='Local Timezone' value={this.viewLocalTimezone} onChange={this.changeTimezone} />
            <button onClick={this.onView}>View</button>
            {!this.filters.origin_code && this.items.length > 0 && <button onClick={this.onLoadMore}>Load More</button>}
          </FormBody>
        </Form>
        <DataTable data={this.items} columns={this.columns} sortRow={items => items.sort((a, b) => a.id > b.id ? -1 : 1)} paginate />
        {this.loading && <Spinner />}
      </div>
    );
  }
}

export default DAQRawData;


// WEBPACK FOOTER //
// ./src/components/DAQRawData.js